import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./pages/Home";
import Sidebar from "./components/Sidebar";
import Chat from "./pages/Chat";
import Login from "./pages/Login";
import { withCookies, Cookies } from 'react-cookie';
import { SocketProvider } from "./context/socketContext";
import { UsersProvider } from "./context/usersContext";

import jwt from 'jsonwebtoken'

const userPrefersDark =
	window.matchMedia &&
	window.matchMedia("(prefers-color-scheme: dark)").matches;

function App() {
	const [isLoggedIn, setIsLoggedIn] = useState(false);
	const [token, setToken] = useState(null);
    const cookies = new Cookies(); // Move this outside of the handleLogin to use it in the useEffect as well.

	useEffect(() => {
		deleteAllCookies();
	
		if (userPrefersDark) document.body.classList.add("dark-theme");
		handleLogin();
	}, []);

	const deleteAllCookies = () => {
		const cookies = document.cookie.split(";");
	
		for (let i = 0; i < cookies.length; i++) {
			const cookie = cookies[i];
			const eqPos = cookie.indexOf("=");
			const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
			
			// Delete cookie with its basic configuration
			document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
			
			// Attempt to delete the cookie with potential configurations
			document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
			document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;secure";
			document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=" + window.location.hostname + ";path=/";
		}
	}

	const handleLogin = () => {
		const token = cookies.get('_auth');
		
		if (token) {
		  try {
			const decoded = jwt.decode(token);
			// Correcting JWT token expiry check
			if (decoded.exp > Date.now() / 1000) { 
			  setIsLoggedIn(true);
			  setToken(token);
			}
		  } catch (err) {
			console.log(err)
		  }
		}
	};

	return (
		<div className={isLoggedIn ? "app-login" : "app"}>
		  {!isLoggedIn ? (
			<Login onLogin={handleLogin} />
		  ) : (
			<div>
			  <p className="app__mobile-message">WhatsApp Web like</p>
			  <SocketProvider token={token}>
			  	<UsersProvider>
					<Router>
					<div className="app-content">
						<Sidebar />
						<Switch>
						<Route path="/chat/:id" component={Chat} />
						<Route component={Home} />
						</Switch>
					</div>
					</Router>
				</UsersProvider>
			  </SocketProvider>
			</div>
		  )}
		</div>
	  );
}

export default withCookies(App);
